<dialog-report-problem (formSubmit)="submit($event)" [isResultState]="isResultState()" [isErrorState]="isErrorState()">
</dialog-report-problem>
